export default class PathUri {
    port;
    context;
    service;

    constructor(port = "", context = "", service = "") {
        this.port = port;
        this.context = context;
        this.service = service;
    }

    generateUri() {
        return this.port + this.context + this.service;
    }
}